import CouponDetails from "modules/checkout/API/apply-coupon-api";
import ActionConstants from "../action-constants";
import Action from "./Action";

class ApplyCouponApiActions extends Action {
  

  //   For API
  static getCouponData(promoCode) {
    return async (dispatch, getState) => {
      const custSeq =
        getState().selectAccount?.selectAccountDetails?.payload?.accountId;

      const response = await CouponDetails.getCouponData(
        custSeq,
        104,
        promoCode
      );

        dispatch(ApplyCouponApiActions.setCouponData(response?.promoCodeDetails));
    };
  }

  private static setCouponData(data) {
    return {
      type: ActionConstants.SET_COUPON_DATA,
      payload: {
        data,
        isFetching: false,
        isSuccess: true
      },
    };
  }
}

export default ApplyCouponApiActions;
